import PropTypes from "prop-types";
import React, { useContext } from "react";
import { GlobalStateContext } from '../context/GlobalContextProvider';
// import Header from "./Header";
import Footer from "./Footer";
function Layout({ children }) {
  const themeState = useContext(GlobalStateContext);
  let style = themeState.theme === 'light' ? 'bg-gray-50' : 'bg-gray-800'

  return (
    <>
      {/* <Header /> */}

      <main className={style}>
        {children}
      </main>
      
      <Footer theme={themeState.theme} />
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;